import type {
  ServerMessage,
  Snapshot,
  SnapshotRef,
  SourceFile,
} from 'ts-components/PiChat/protocol';
import { httpOriginFromWsUrl } from './captureUrl';

const refsOf = (
  message: ServerMessage
): Pick<SnapshotRef, 'id' | 'filesUrl'>[] => {
  switch (message.type) {
    case 'session.ready':
      return message.snapshots ?? [];
    case 'push.result':
      return [message.snapshot];
    case 'snapshot.restored':
      return [{ id: message.snapshotId, filesUrl: message.filesUrl }];
    default:
      return [];
  }
};

export const versionFilesUrls = (message: ServerMessage) =>
  refsOf(message).flatMap(({ id, filesUrl }) =>
    filesUrl ? [{ snapshotId: id, filesUrl }] : []
  );

export const fetchVersionFiles = async (
  filesUrl: string,
  wsUrl: string,
  signal: AbortSignal
): Promise<SourceFile[]> => {
  const response = await fetch(
    new URL(filesUrl, httpOriginFromWsUrl(wsUrl) ?? undefined),
    { signal }
  );
  if (!response.ok) throw new Error(`HTTP ${response.status}`);
  const snapshot: Snapshot = await response.json();
  return snapshot.files;
};
